import {
  AllOrganizationalUnitsFilter,
  Identifiable,
  OrganizationalUnit,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type LinkedOrganizationalUnit = {
  uuid: string;
  name: string;
  rankKey: string;
  parentUuid: string | null;
  hasChildren: boolean;
};

type Response = {
  _embedded: {
    organizationalUnits: LinkedOrganizationalUnit[];
  };
  page: {
    size: number;
    totalElements: number;
    totalPages: number;
    number: number;
  };
};

// Every unit in tree order, searched by name with its ancestors, for the unit pickers: the tree endpoint
// only returns the units matching the OBS page filters.
function getAllOrganizationalUnits(httpClient: HttpClient) {
  return ({ name, excludedUuid, page, size }: AllOrganizationalUnitsFilter) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: "/organizational-units/hierarchy",
        method: HttpMethods.POST,
        data: { name, excludedUuid: excludedUuid || undefined, page, size },
      })
      .then(({ _embedded, page }) => ({
        organizationalUnits: _embedded.organizationalUnits.map(
          (unit): Identifiable<OrganizationalUnit> => ({
            uuid: unit.uuid,
            name: unit.name,
            rankKey: unit.rankKey,
            parentUuid: unit.parentUuid ?? undefined,
            hasChildren: unit.hasChildren,
          }),
        ),
        totalPages: page.totalPages,
      }))
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { getAllOrganizationalUnits };
